import React, {Component, Fragment} from "react";
import TextInput from "ps-react/TextInput";

class ExampleError extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<TextInput
				htmlId="example-optional"
				name="firstname"
				label="First name"
				onChange={this.handleChange }
				required
				error="First name is required"
			/>
		);
	}
}

export default ExampleError;
